<script setup lang="ts">
import { repository } from "~/repository";

import MarketingSection from "~/components/Home/Marketing/MarketingSection.vue";
import ChoosePlan from "~/components/Home/Marketing/ChoosePlan.vue";
import Faq from "~/components/Home/Marketing/Faq.vue";
import MainDesktop from "~/components/Home/Marketing/MainDesktop.vue";
import MainMobile from "~/components/Home/Marketing/MainMobile.vue";

const { data, pending } = await useAsyncData(
  () => repository.common.fetchMarketingData(),
  {
    lazy: true,
  },
);

const choosePlanRef = ref<HTMLElement | null>(null);

const scrollToChoosePlan = () => {
  choosePlanRef.value?.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });
};

const contentRef = ref<HTMLElement | null>(null);

const scrollToContent = () => {
  contentRef.value?.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });
};
</script>

<template>
  <div :class="['bg-contain bg-top bg-no-repeat']">
    <div class="h-20" />
    <div class="m-auto max-w-screen-xl px-5 py-10">
      <div v-if="pending" class="mt-20 text-center">
        <ProgressSpinner class="!h-20 !w-20" />
      </div>
      <div v-else-if="data">
        <div class="text-center">
          <MainMobile
            class="md:hidden"
            @scroll-to-choose-plan="scrollToChoosePlan"
          />

          <MainDesktop
            class="hidden md:block"
            @scroll-to-content="scrollToContent"
          />
        </div>
        <div>
          <Banner page="marketing" location="header" />
        </div>

        <div ref="contentRef">
          <div
            v-for="(section, idx) in data?.data?.section"
            :key="`section_${idx}`"
            class="mt-10"
          >
            <MarketingSection
              :title="section.title"
              :description="section.description"
              :tiles="section.tiles"
              :design-type="section.design_type"
            />
          </div>
        </div>

        <div ref="choosePlanRef">
          <ChoosePlan />
        </div>

        <Faq :faq="data?.data?.faq || []" />
        <Devices />
      </div>
    </div>
  </div>
  <div></div>
</template>

<style scoped></style>
